import { render, staticRenderFns } from "./WithdrawWait.vue?vue&type=template&id=50f2d568&"
import script from "./WithdrawWait.vue?vue&type=script&lang=js&"
export * from "./WithdrawWait.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawWait.vue?vue&type=style&index=0&id=50f2d568&prod&lang=scss&scooped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports